<template>
  <v-container fill-height>
    <v-row justify="center">
      <v-col xs="12" sm="8" md="4">
        <div class="text-center mb-6">
          <h1 class="grey--text text--darken-1 font-weight-light">Urgencias</h1>
          <v-img src="https://medicover.mx/img/login-urgencias.png" max-height="140" contain
            class="mx-auto my-4 rounded-lg"></v-img>
          <v-divider></v-divider>
        </div>

        <h3 class="grey--text text--darken-1 font-weight-regular mb-4 text-center">
          Ingresa tus credenciales
        </h3>

        <v-form @submit.prevent="login" ref="loginForm">
          <v-text-field v-model="email" label="Ingresa usuario" outlined dense clearable required
            prepend-inner-icon="mdi-email" class="mb-4"></v-text-field>

          <v-text-field v-model="password" :type="showPassword ? 'text' : 'password'" label="Contraseña" outlined dense
            clearable :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append="togglePasswordVisibility"
            :rules="contrarquerido" required prepend-inner-icon="mdi-lock" class="mb-4"></v-text-field>

          <v-alert v-if="mostrarerror" type="error" dense text class="mb-4">
            {{ errormensaje }}
          </v-alert>

          <v-row no-gutters justify="center" class="">
            <v-col cols="12" class="text-center">
              <v-btn :href="WhatsApp" target="_blank" text small color="grey darken-1" class="font-weight-medium"
                style="text-transform: none;">
                ¿Necesitas ayuda para iniciar sesión?
              </v-btn>
            </v-col>
          </v-row>
          <v-btn color="azul_med" depressed block large rounded dark type="submit">
            Iniciar sesión
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>

</template>
<script>

export default {
  name: 'LoginView',
  validations: {
  },
  data: () => ({
    WhatsApp: `https://wa.me/send?phone=${process.env.VUE_APP_BASE_PHONEWHATSWEB}&text=${encodeURIComponent('Hola, necesito ayuda al iniciar sesión como hospital')}`,
    email: '',
    mostrarerror: false,
    errormensaje: null,
    password: '',
    showPassword: false,
    contrarquerido: [
      (v) => !!v || 'Contraseña requerida'
    ]
  }),
  computed: {
    checkboxErrors() {
      const errors = []
      if (!this.$v.checkbox.$dirty) return errors
      // !this.$v.checkbox.checked && errors.push('You must agree to continue!');
      return errors
    },
    selectErrors() {
      const errors = []
      if (!this.$v.select.$dirty) return errors
      // !this.$v.select.required && errors.push('Item is required');
      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long');
      // !this.$v.name.required && errors.push('Name is required.');
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      // !this.$v.email.email && errors.push('Must be valid e-mail');
      // !this.$v.email.required && errors.push('E-mail is required');
      return errors
    }
  },
  created() {
    this.$store
      .dispatch('logout', {})
  },
  beforeMount() {
  },
  mounted() {
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    validate() {
      // this.$refs.form.validate();
    },
    async login() {
      try {
        //Se pudiera esperar url del backend
        await this.$store.dispatch('login', {
          email: this.email,
          password: this.password,
          tipo: 'hospital'
        });
        const redirect = this.$route.query.redirect;
        console.log(redirect)
        //this.$router.replace(redirect);
        this.$router.replace('/hospital/urgencias-medicas');
      } catch (error) {
        this.mostrarerror = true;
        this.errormensaje = "Ocurrió un error al procesar tu solicitud.";
      }
    },
    submit() {
      this.$v.$touch()
    },
    clear() {
      this.$v.$reset()
      this.name = ''
      this.email = ''
    }
  }
}
</script>
